export class NumberUtils {
  public static roundAwayFromZero(value: number): number {
    return Math.sign(value) * Math.round(Math.abs(value));
  }

  public static withUnitComparator(valueA: string, valueB: string): number {
    if (!valueA && !valueB) {
      return 0;
    }

    if (!valueA) {
      return -1;
    }

    if (!valueB) {
      return 1;
    }

    const [numA, strA] = valueA.split(' ');
    const [numB, strB] = valueB.split(' ');

    const upperStrA = strA?.toUpperCase() || '';
    const upperStrB = strB?.toUpperCase() || '';

    if (upperStrA === upperStrB) {
      const numberA = Number(numA);
      const numberB = Number(numB);
      const numberComparison = numberA > numberB ? 1 : -1;
      return numberA === numberB ? 0 : numberComparison;
    }

    return upperStrA > upperStrB ? 1 : -1;
  }
}
